






import { Vue, Component, Prop } from "vue-property-decorator";
import { ICustomStylingClass } from "@/components/Globals/types/custom.t";
import CustomTooltip from "@/components/Globals/atom.tabTooltip.vue"

@Component({
  components: {
    CustomTooltip
  }
})
export default class TabTooltip extends Vue {
  @Prop()
  customsClasses?: ICustomStylingClass[];

  @Prop()
  tooltip!: string;

  get pdm() {
    return this.$store.state.utils.pdm;
  }

  get ugcTooltipData() {
    const ugcPriceToolTip = this.pdm?.ugcPriceToolTip;
    const data = {
      trigger: ugcPriceToolTip ? 'click hover' : 'manual',
      content:  ugcPriceToolTip || '',
      delay: { show: 500 },
      show: false
    };
    if (!ugcPriceToolTip) data.show = false;
    return data;
  }
}
